import { Component, Input } from "@angular/core";
import { IPulseRecord } from "../../../_models/IPulseRecord";
import { IPulseRecordPayload } from "../../../_models/IPulseRecordPayload";
import './pulse-message-detail.component.scss';

@Component({
    selector: 'pulse-message-detail',
    template: require('./pulse-message-detail.component.html')
})
export class PulseMessageDetailComponent {
    @Input() pulseRecord: IPulseRecord;
    pulsePayload: IPulseRecordPayload;

    ngOnChanges(): void {
        this.pulsePayload = this.pulseRecord.parsedPayload;
    }
}
